import { arrayMove } from '@dnd-kit/sortable';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  archived: [],
  unscheduled: [],
  suggested: [],
};

const campaignDndSlice = createSlice({
  name: 'campaignDnd',
  initialState,
  reducers: {
    setShelfTiles(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    removeTileFromPost(state, { payload }) {
      const { postKey, tiles } = payload;

      const postObject = { [postKey]: [...tiles] };

      return {
        ...state,
        ...postObject,
      };
    },
    setPostTiles(state, { payload }) {
      const postObject = payload.reduce((acc, post) => {
        return {
          ...acc,
          [`post-${post.uuid}`]: [...post.tiles],
        };
      }, {});

      return {
        archived: state.archived,
        unscheduled: state.unscheduled,
        suggested: state.suggested,
        ...postObject,
      };
    },
    dragTileOver(state, { payload }) {
      const { activeContainer, overContainer, active } = payload;

      return {
        ...state,
        [activeContainer]: state[activeContainer].filter(
          item => item.id !== active.id,
        ),
        [overContainer]: [
          ...state[overContainer].filter(item => item.id !== active.id),
          { ...active.data.current, status: overContainer },
        ],
      };
    },
    dragEnd(state, { payload }) {
      const { overId, tile } = payload;

      const oldIndex = state[tile.status].findIndex(t => t.id === tile.id);
      const newIndex = state[tile.status].findIndex(t => t.id === overId);

      if (newIndex === oldIndex) {
        return state;
      }

      return {
        ...state,
        [tile.status]: arrayMove(state[tile.status], oldIndex, newIndex),
      };
    },
  },
});

export const {
  setShelfTiles,
  setPostTiles,
  removeTileFromPost,
  dragTileOver,
  dragEnd,
} = campaignDndSlice.actions;
export default campaignDndSlice.reducer;
